<template>
  <div class="row mt-3">
    <loader v-if="!lastSession"></loader>

    <div class="col-12" v-if="lastSession">
      <div class="row mb-3"  v-for="row in lastSession.answers">
        <div class="col-12"  v-for="dataProp in row.rowData">

          <h4 class="stage-results__subtitle">{{'protocol.categoryTitle' | trans}}: {{lastSession.categories[row.categoryId]}}. <span class="nowrap">{{toLocaleDate(lastSession.day)}}</span>.</h4>
          <p class="stage-results__subtitle">
            {{'protocol.propertyTitle' | trans}}: {{lastSession.stimuli[dataProp.global_id]}}.
          </p>
          <table class="stage-results-table table table-sm" v-if="dataProp.answers.length">
            <thead class="thead-light">
              <tr>
                <th class="pl-3">
                  {{'protocol.number_of_trials' | trans}}
                </th>
                <th class="text-center">
                  {{'protocol.compliance_check' | trans}}
                </th>
              </tr>
            </thead>
            <tbody>

              <tr v-for="(taskData, indexTaskData) in dataProp.answers">
                <td class="pl-3">
                  {{indexTaskData + 1}}
                </td>
                <td class="text-center">
                  {{taskData.title | trans}}
                </td>
              </tr>

            </tbody>

          </table>

        </div>
      </div>

      <h5 class="text-center" v-if="!lastSession.answers || (lastSession.answers && !lastSession.answers.length)">{{'bids.no_data' | trans }}</h5>

    </div>

  </div>
</template>
<script>
  import moment from 'moment';
  import axios from 'axios';
  import lang from '../../../lang/translator';
  import {mapGetters} from 'vuex';
  import filter from 'lodash/filter';
  import Loader from '../../loader/components/Loader';

  export default {

    data() {
      return {
        apiUrl: '/protocols/assigned/pecs-with-discrimination/',
        lastSession: null,
      }
    },

    props: {
      'stage': {
        default() {
          return null;
        },
      },
      'protocolId': {
        default() {
          return null;
        },
      },

    },
    components: {
      Loader
    },
    computed: {
      ...mapGetters('mobile', [
        'isMobile',
      ]),
    },
    async created() {
      this.fetchMeasurementLastSession();
    },
    methods:{
      toLocaleDate: function (date) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
      },
      trans: function (key) {
        return lang.get(key);
      },

      fetchMeasurementLastSession: async function () {
        try {
          let response = await axios.get(this.apiUrl + this.protocolId + '/last-sessions/stage/' + this.stage.id);
          this.lastSession = response.data.data;

        } catch (error) {
          console.dir(error);
          if(error.status === 403) {
            //this.$router.push({name: 'client-edit', params: { clientId: this.clientId || this.assignedProtocolId }});
          }
        }
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/modules/dashboardParent/components/LastSessionCategoryResults.vue